import React from 'react';
import {useParams} from 'react-router-dom';
import {FeatureFlagEnum} from 'src/api/ProactApiClient';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ItemAssignmentForm} from 'src/app/item-tracker/ItemAssignmentForm';
import {itemAssignmentDocumentTitle} from 'src/app/item-tracker/itemAssignmentHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const ItemTrackerReviewPage: React.FC = () => {
  useSetDocumentTitle(`${itemAssignmentDocumentTitle} - Review`);
  const {definitionId, id} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      {id !== undefined && (
        <ItemAssignmentForm
          definitionId={Number(definitionId)}
          id={Number(id)}
          mode="view"
          enableEdit={false}
          enableTransitions={true}
          fromDashboard={true}
        />
      )}
    </ContentWrapper>
  );
};

export default ItemTrackerReviewPage;

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.ItemTrackerReview(':definitionId', ':id'),
  element: <ItemTrackerReviewPage />,
  isPrivate: true,
});
